import { Component, inject } from '@angular/core';
import { ThemeService } from '@core/theme/presentation/presentation';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  // Injected for its constructor side effect: re-stamping the theme attributes once
  // Angular boots and following the OS setting from then on. Nothing reads this field
  // — the injection is what instantiates the service, and the root component is the
  // one place guaranteed to be created on every route.
  private readonly _theme = inject(ThemeService);
}
